import { Form, IForm } from './Form';
import { Employee } from '@/classes/InjuryForm/Employee';
import { Student } from '@/classes/InjuryForm/Student';
import { Injury } from '@/classes/InjuryForm/Injury';
import { Witness } from '@/classes/InjuryForm/Witness';
import { SupervisorReport } from '@/classes/InjuryForm/SupervisorReport';
import { FieldCoordinatorReview } from '@/classes/InjuryForm/FieldCoordinatorReview';
import InjuryDocument from './InjuryDocument';

interface IInjuryForm extends IForm {
    injuredPerson?: string;
    employee?: Employee;
    student?: Student;
    injury?: Injury;
    witnesses?: Witness[];
    noWitness?: boolean;
    supervisorReport?: SupervisorReport;
    fieldCoordinatorReview?: FieldCoordinatorReview;
    injuryDocumentIds?: number[];
}

class InjuryForm extends Form implements IInjuryForm {
    public injuredPerson?: string;
    public employee?: Employee;
    public student?: Student;
    public injury?: Injury;
    public witnesses?: Witness[];
    public noWitness?: boolean;
    public supervisorReport?: SupervisorReport;
    public fieldCoordinatorReview?: FieldCoordinatorReview;
    public injuryDocumentIds?: number[];

    constructor(m: IInjuryForm = {}) {
        super(m);
        this.injuredPerson = m.injuredPerson;
        this.isActive = m.isActive;
        this.employee = new Employee(m.employee);
        this.student = new Student(m.student);
        this.injury = new Injury(m.injury);
        this.witnesses = m.witnesses === undefined ? [new Witness({})] : m.witnesses.map((i) => new Witness(i));
        this.noWitness = m.noWitness;
        this.supervisorReport = new SupervisorReport(m.supervisorReport);
        this.fieldCoordinatorReview = new FieldCoordinatorReview(m.fieldCoordinatorReview);
        this.type = m.injuredPerson === 'student' ? 'Student Injury Report' : 'Employee Injury Report';
        this.injuryDocumentIds = m.injuryDocumentIds !== undefined && m.injuryDocumentIds !== null ? m.injuryDocumentIds : [];
    }

    public failedFieldMessages() {
        return this.isSupervisorTabComplete();
    }

    public isStudentEmployeeTabComplete(): boolean {
        let valid = false;
        if (this.injuredPerson === 'student') {
            if (this.student) {
                if (this.student.isValid()) {
                    valid = true;
                }
            }
        } else if (this.injuredPerson === 'employee') {
            if (this.employee) {
                if (this.employee.isValid()) {
                    valid = true;
                }
            }
        }
        if (this.jobCorpsCenterId === undefined || this.jobCorpsCenterId === null) {
            valid = false;
        }
        return valid;
    }

    public isInjuryTabComplete(): boolean {
        let validations: string[] = [];
        if (this.injury) {
            if (this.injuredPerson === 'employee') {
                if (this.employee === undefined || this.employee.occupation === undefined || this.employee.occupation.length === 0) {
                    validations.push('occupation');
                }
            }
            validations = validations.concat(this.injury.isValid());
        }
        return validations.length === 0;
    }

    public isWitnessTabComplete(): boolean {
        let validations: string[] = [];
        if (this.noWitness === true) {
            validations = [];
        } else if (this.witnesses && this.witnesses.length > 0) {
            validations = validations.concat(this.witnesses[0].isWitnessTabValid());
        }
        return validations.length === 0;
    }

    public isFieldCoordinatorTabComplete(): boolean {
        let validations: string[] = [];
        if (this.fieldCoordinatorReview) {
            validations = validations.concat(this.fieldCoordinatorReview.isFieldCoordinatorTabValid());
        } else {
            validations.push('fieldCoordinatorReview');
        }
        return validations.length === 0;
    }

    public isSupervisorTabComplete(): boolean {
        let validations: string[] = [];
        if (this.supervisorReport) {
            validations = validations.concat(
                this.supervisorReport.isSupervisorTabValid(this.injuredPerson === 'employee' ? this.employee : undefined));
        } else {
            validations.push('supervisorReport');
        }
        return validations.length === 0;
    }

    public supervisorTabComplete(): string[] {
        if (this.supervisorReport) {
            return this.supervisorReport.isSupervisorTabValid(this.injuredPerson === 'employee' ? this.employee : undefined);
        } else {
            return [];
        }
    }
}

export default InjuryForm;
export { InjuryForm, IInjuryForm };
